import { render, staticRenderFns } from "./SlotToolBarItem.vue?vue&type=template&id=bbaa058a&scoped=true&"
import script from "./SlotToolBarItem.vue?vue&type=script&lang=js&"
export * from "./SlotToolBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SlotToolBarItem.vue?vue&type=style&index=0&id=bbaa058a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaa058a",
  null
  
)

export default component.exports